module.exports = __webpack_public_path__ + "img/nabl_gallery7.58f2cf5c.jpg";